var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{staticStyle:{"z-index":"100"},attrs:{"value":_vm.loading}},[_c('v-progress-circular',{attrs:{"size":70,"width":4,"color":"primary","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }